// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-6a0ac0a0] {\r\n  /*85 = navbar + tagsview  */\r\n  height: calc(100vh - 90px);\r\n  width: 100%;\r\n  /* overflow:auto; */\r\n  position: relative;\r\n  background: #fff;\n}\n.fixed-header+.app-main[data-v-6a0ac0a0] {\r\n  padding-top: 50px;\n}\r\n", ""]);
// Exports
module.exports = exports;
